import { Fragment, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Breadcrumbs as MantineBreadcrumbs, Title } from "@mantine/core";
import { IconChevronRight } from "@tabler/icons-react";

import { Link } from "../Link";

export interface BreadcrumbsProps {
    items: {
        title: ReactNode;
        path?: string;
    }[];
}
export const Breadcrumbs = ({ items }: BreadcrumbsProps) => {
    const { t } = useTranslation(["common"]);

    return (
        <MantineBreadcrumbs separator={<IconChevronRight size={16} />}>
            {items.map((item, index) => {
                const key = `${index}${(item?.title || "").toString()}`;

                if (index === items.length - 1) {
                    return (
                        <Title key={key} order={5}>
                            {item?.title}
                        </Title>
                    );
                }

                if (!item?.path) {
                    return <Fragment key={key}>{item?.title}</Fragment>;
                }

                return (
                    <Link key={key} to={item.path}>
                        {item.title}
                    </Link>
                );
            })}
        </MantineBreadcrumbs>
    );
};
